import { REDUX_STORE } from '@funnels/constants';
import { ActiveRoles, UpdateActiveRolesAction, UpdateActiveRolesErrorAction } from '@funnels/types';

export function updateActiveRoles(activeRoles: ActiveRoles): UpdateActiveRolesAction {
  return { type: REDUX_STORE.ACTIVE_ROLES.ACTION_TYPES.UPDATE_ACTIVE_ROLES, activeRoles };
}

export function updateActiveRolesError(error: any = 'Unknown error'): UpdateActiveRolesErrorAction {
  return { type: REDUX_STORE.ACTIVE_ROLES.ACTION_TYPES.UPDATE_ACTIVE_ROLES_ERROR, error };
}
